import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { fontSize, fontWeight, textAlign, width } from "@mui/system";
import * as React from "react";
import { IconButton } from "@mui/material";

interface StyledTableCellProps {
  isAgentTable?: boolean;
  columnWidth?: string | number;
  isSort: boolean;
}
const StyledTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "isAgent",
})<StyledTableCellProps>(({ isAgentTable, columnWidth, isSort }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: isAgentTable ? "#F4F7FBB2" : "#F4F7FBB2", // Dynamic background
    color: isAgentTable ? "#01060B" : "#6C6F71",
    borderBottom: "1px solid #E1E2E9",
    borderTop: isAgentTable && "1px solid #E1E2E9",
    padding: isSort ? "16px 15px" : "16px 24px",
    textAlign: "left",
    whiteSpace: "nowrap",
    textTransform: "uppercase",

    // width: isAgentTable ? columnWidth : "100%",
  },
  // [`&.${tableCellClasses.body}`]: {
  //   fontSize: 14,
  //   padding: "16px 24px",
  //   whiteSpace: "nowrap",
  //   borderBottom: "1px solid red !important",
  // },

  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: "16px 24px",
    borderBottom: "1px solid #EAF1FA",
    whiteSpace: "nowrap",
    overflow: "hidden", // ← required
    textOverflow: "ellipsis", // ← required
    maxWidth: "200px", // ← or whatever fixed width you need
  },
}));

const StyledTableRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== "isAgent",
})<StyledTableCellProps>(({ isAgentTable }) => ({
  "& td, & th": {
    borderBottom: "1px solid #EAF1FA",
    padding: "16px 24px",
    fontSize: isAgentTable && "14px",
    fontWeight: isAgentTable && 400,
    color: isAgentTable && "#6C6F71",
    whiteSpace: "nowrap",
  },
}));

export default function CustomTable(props: any) {
  const {
    headings,
    children,
    isAgentTable,
    sortOrder,
    orderBy,
    order,
    isSort,
  } = props;
  const columnWidth = `${100 / headings.length}%`;
  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: "none",
        borderRadius: "0px",
        // p: 2,
      }}
    >
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            {headings.map((item: string, index: number) => (
              <StyledTableCell
                key={index}
                align={index === 0 && isAgentTable ? "inherit" : "center"}
                isAgentTable={isAgentTable}
                columnWidth={columnWidth}
                sx={{ width: columnWidth, whiteSpace: "nowrap" }}
                isSort={isSort}
              >
                {isSort ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 4,
                      marginLeft: "-10px",
                    }}
                  >
                    <IconButton
                      onClick={() => sortOrder(item)}
                      size="small"
                      sx={{
                        color:
                          order === "asc" && orderBy === item
                            ? "#1976d2"
                            : "inherit",
                      }}
                    >
                      {item !== "ACTION" && (
                        <SwapVertIcon sx={{ fontSize: 20 }} />
                      )}
                    </IconButton>

                    <span>{item}</span>
                  </div>
                ) : (
                  item
                )}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {" "}
          {React.Children.map(children, (child) =>
            React.cloneElement(child, {
              component: StyledTableRow,
              isAgentTable,
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
